import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetMediaUniformGalleryResponse,
  PostMediaUniformGalleryResponse,
  GetMediaUniformGalleryByIdResponse,
  PutMediaUniformGalleryResponse,
} from '../response/uniform-gallery';

export class UniformGalleryService {
  static getUniformGalleries(params?: QueryParams) {
    return apiClient.get<GetMediaUniformGalleryResponse>(buildApiUrl('/api/v1/media/uniform-gallery'), params);
  }

  static postUniformGallery(data: any) {
    return apiClient.createWithFile<PostMediaUniformGalleryResponse>(buildApiUrl('/api/v1/media/uniform-gallery'), data);
  }

  static getUniformGalleryById(id: string) {
    return apiClient.get<GetMediaUniformGalleryByIdResponse>(buildApiUrl('/api/v1/media/uniform-gallery/:id', { id }), undefined);
  }

  static putUniformGallery(id: string, data: any) {
    return apiClient.updateWithFile<PutMediaUniformGalleryResponse>(buildApiUrl('/api/v1/media/uniform-gallery/:id', { id }), data);
  }

  static deleteUniformGallery(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/media/uniform-gallery/:id', { id }), undefined);
  }
}
